import { render, staticRenderFns } from "./NuevaDeduccion.vue?vue&type=template&id=0d254e9a"
import script from "./NuevaDeduccion.vue?vue&type=script&lang=js"
export * from "./NuevaDeduccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports